import React from 'react'
import { toSlug } from 'ak-react-utils'
import { Card } from 'react-bootstrap'

import { layoutConfigFor } from '../../utils'
import CmsLink from '../CmsLink'
import useDomainLayoutsQuery from '../../hooks/useDomainLayoutsQuery'
import Markdown from '../Markdown'

const ItemImageCard = ({ item }) => {
  const {
    domain: {
      domain_settings
    }
  } = useDomainLayoutsQuery()

  const { item_image_config } = layoutConfigFor(item.parent.parent.layout, domain_settings)

  return (
    <Card className='h-100 item-image-card'>
      <Card.Img
        variant='top'
        loading='lazy'
        className='h-auto'
        src={ item.image_url }
        width={item_image_config.width}
        height={item_image_config.height}
      />
      <Card.Body className='item-content'>
        <Card.Title id={ toSlug(item.headline) } className='item-headline'>
          { item.headline }
        </Card.Title>
        {item.body && (
          <Markdown className='item-body'>
            { item.body }
          </Markdown>
        )}
      </Card.Body>
      <Card.Footer className='pb-3'>
        <CmsLink object={item} className='item-link btn btn-outline-primary'>Mehr</CmsLink>
      </Card.Footer>
    </Card>
  )
}

export default ItemImageCard
